module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "site-wrapper"
  }, [_c('Loader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }]
  }), (_vm.props && !_vm.loading) ? _c('div', {
    staticClass: "site-inner",
    attrs: {
      "id": "test"
    }
  }, [_c('Header'), _c('div', {
    staticClass: "home-content",
    attrs: {
      "id": "content"
    }
  }, [_c('Hero'), _c('section', {
    staticClass: "scrolled-sec",
    attrs: {
      "id": "about-us"
    }
  }, [(_vm.props.acf.homeaboutheading) ? _c('h3', {
    staticClass: "heading",
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.homeaboutheading)
    }
  }) : _vm._e(), _c('div', {
    staticClass: "about-slider"
  }, [_c('swiper', {
    attrs: {
      "options": _vm.swiperOption2
    }
  }, _vm._l((_vm.props.acf.homeaboutslider), function(aboutUsSlider, i) {
    return _c('swiper-slide', {
      key: aboutUsSlider.id,
      style: ({
        backgroundImage: 'url(' + aboutUsSlider.backgroundimage + ')'
      })
    }, [_c('div', {
      staticClass: "slide-content-wrapper"
    }, [(aboutUsSlider.docterimage) ? _c('div', {
      staticClass: "content-picture",
      style: ({
        backgroundImage: 'url(' + aboutUsSlider.docterimage + ')'
      })
    }) : _vm._e(), (aboutUsSlider.dcotername) ? _c('div', {
      staticClass: "content-inner"
    }, [_c('div', {
      staticClass: "content-caption"
    }, [_c('h3', {
      domProps: {
        "innerHTML": _vm._s(aboutUsSlider.dcotername)
      }
    }), _c('div', {
      staticClass: "content",
      domProps: {
        "innerHTML": _vm._s(aboutUsSlider.aboutdocter)
      }
    }), (aboutUsSlider.aboutdocterreadmore) ? _c('b-button', {
      directives: [{
        name: "b-modal",
        rawName: "v-b-modal.modal-scrollable",
        modifiers: {
          "modal-scrollable": true
        }
      }],
      staticClass: "modal-trigger",
      attrs: {
        "id": "readDocBioDesktopBtn" + i
      },
      on: {
        "click": function($event) {
          _vm.$bvModal.show('readDocBioDesktop' + i)
        }
      }
    }, [_vm._v("Read More")]) : _vm._e(), (aboutUsSlider.aboutdocterreadmore) ? _c('b-modal', {
      attrs: {
        "id": "readDocBioDesktop" + i,
        "size": "xl",
        "hide-footer": "",
        "title": aboutUsSlider.dcotername
      }
    }, [_c('div', {
      staticClass: "simple-modal-content"
    }, [_c('div', {
      staticClass: "content",
      domProps: {
        "innerHTML": _vm._s(aboutUsSlider.aboutdocter)
      }
    }), _c('div', {
      staticClass: "content",
      domProps: {
        "innerHTML": _vm._s(aboutUsSlider.aboutdocterreadmore)
      }
    })])]) : _vm._e(), (aboutUsSlider.aboutdocterreadmore) ? _c('b-button', {
      directives: [{
        name: "b-modal",
        rawName: "v-b-modal.modal-scrollable",
        modifiers: {
          "modal-scrollable": true
        }
      }],
      staticClass: "modal-trigger blue",
      attrs: {
        "id": "readDocBioMobileBtn" + i
      },
      on: {
        "click": function($event) {
          _vm.$bvModal.show('readDocBioMobile' + i)
        }
      }
    }, [_vm._v("Read More")]) : _vm._e(), (aboutUsSlider.aboutdocterreadmore) ? _c('b-modal', {
      attrs: {
        "id": "readDocBioMobile" + i,
        "size": "xl",
        "hide-footer": "",
        "title": aboutUsSlider.dcotername
      }
    }, [_c('div', {
      staticClass: "simple-modal-content"
    }, [_c('div', {
      staticClass: "content",
      domProps: {
        "innerHTML": _vm._s(aboutUsSlider.aboutdocter)
      }
    }), _c('div', {
      staticClass: "content",
      domProps: {
        "innerHTML": _vm._s(aboutUsSlider.aboutdocterreadmore)
      }
    })])]) : _vm._e()], 1)]) : _vm._e(), _c('div', {
      staticClass: "swiper-button-prev swiper-button-prev2",
      attrs: {
        "slot": "button-prev"
      },
      slot: "button-prev"
    }, [_c('div', {
      staticClass: "fa fa-angle-left"
    })]), _c('div', {
      staticClass: "swiper-button-next swiper-button-next2",
      attrs: {
        "slot": "button-next"
      },
      slot: "button-next"
    }, [_c('div', {
      staticClass: "fa fa-angle-right"
    })])])])
  }))], 1)]), _c('section', {
    staticClass: "scrolled-sec",
    attrs: {
      "id": "our-team"
    }
  }, [_c('div', {
    staticClass: "section-container"
  }, [(_vm.props.acf.homeourteamheading) ? _c('h3', {
    staticClass: "heading",
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.homeourteamheading)
    }
  }) : _vm._e(), _c('div', {
    staticClass: "banner-slider"
  }, [_c('swiper', {
    attrs: {
      "options": _vm.swiperOption3
    }
  }, _vm._l((_vm.props.acf.homeourteambannerimage), function(bannerSliderteam, i) {
    return _c('swiper-slide', {
      key: bannerSliderteam.id,
      style: ({
        backgroundImage: 'url(' + bannerSliderteam.images + ')'
      })
    }, [_c('div', {
      staticClass: "slide-content-wrapper"
    }, [_c('div', {
      staticClass: "swiper-button-prev swiper-button-prev3",
      attrs: {
        "slot": "button-prev"
      },
      slot: "button-prev"
    }, [_c('div', {
      staticClass: "fa fa-angle-left"
    })]), _c('div', {
      staticClass: "swiper-button-next swiper-button-next3",
      attrs: {
        "slot": "button-next"
      },
      slot: "button-next"
    }, [_c('div', {
      staticClass: "fa fa-angle-right"
    })])])])
  }))], 1), _c('div', {
    staticClass: "content-info"
  }, [(_vm.props.acf.homeourteamcontent) ? _c('div', {
    staticClass: "content",
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.homeourteamcontent)
    }
  }) : _vm._e(), (_vm.props.acf.homeourteammorecontent) ? _c('b-button', {
    staticClass: "modal-trigger",
    attrs: {
      "id": "readBioAboutTeam"
    },
    on: {
      "click": function($event) {
        _vm.$bvModal.show('readBioAboutTeam')
      }
    }
  }, [_vm._v("Read More")]) : _vm._e(), (_vm.props.acf.homeourteammorecontent) ? _c('b-modal', {
    attrs: {
      "id": "readBioAboutTeam",
      "size": "xl",
      "hide-footer": "",
      "title": _vm.props.acf.homeourteamheading
    }
  }, [_c('div', {
    staticClass: "simple-modal-content"
  }, [_c('div', {
    staticClass: "content",
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.homeourteamcontent)
    }
  }), _c('div', {
    staticClass: "content",
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.homeourteammorecontent)
    }
  })])]) : _vm._e()], 1)])]), _c('section', {
    staticClass: "scrolled-sec",
    attrs: {
      "id": "covid-info"
    }
  }, [_c('div', {
    staticClass: "section-container"
  }, [(_vm.props.acf.homecovidheading) ? _c('h3', {
    staticClass: "heading",
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.homecovidheading)
    }
  }) : _vm._e(), _c('div', {
    staticClass: "section-banner",
    style: ({
      backgroundImage: 'url(' + _vm.props.acf.homecovidbackgroundimage + ')'
    })
  }), _c('div', {
    staticClass: "content-info"
  }, [(_vm.props.acf.homecovidinfo) ? _c('div', {
    staticClass: "content",
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.homecovidinfo)
    }
  }) : _vm._e(), (_vm.props.acf.homecovidmoreinfo) ? _c('b-button', {
    staticClass: "modal-trigger",
    attrs: {
      "id": "readBioAboutCovid"
    },
    on: {
      "click": function($event) {
        _vm.$bvModal.show('readBioAboutCovid')
      }
    }
  }, [_vm._v("Read full Message to Our Patients...")]) : _vm._e(), (_vm.props.acf.homecovidmoreinfo) ? _c('b-modal', {
    attrs: {
      "id": "readBioAboutCovid",
      "size": "xl",
      "hide-footer": "",
      "title": _vm.props.acf.homecovidheading
    }
  }, [_c('div', {
    staticClass: "simple-modal-content"
  }, [_c('div', {
    staticClass: "content",
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.homecovidinfo)
    }
  }), _c('div', {
    staticClass: "content",
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.homecovidmoreinfo)
    }
  })])]) : _vm._e(), (_vm.props.acf.homepreviousannouncementcontent) ? _c('b-button', {
    staticClass: "modal-trigger",
    attrs: {
      "id": "readCovidLatestAnnouncement"
    },
    on: {
      "click": function($event) {
        _vm.$bvModal.show('readCovidLatestAnnouncement')
      }
    }
  }, [_vm._v("Read Latest Announcement Re: COVID-19")]) : _vm._e(), (_vm.props.acf.homepreviousannouncementcontent) ? _c('b-modal', {
    attrs: {
      "id": "readCovidLatestAnnouncement",
      "size": "xl",
      "hide-footer": "",
      "title": _vm.props.acf.homepreviousannouncementheading
    }
  }, [_c('div', {
    staticClass: "simple-modal-content"
  }, [_c('div', {
    staticClass: "content",
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.homepreviousannouncementcontent)
    }
  })])]) : _vm._e(), (_vm.props.acf.homelatestsannouncementcontent) ? _c('b-button', {
    staticClass: "modal-trigger",
    attrs: {
      "id": "readCovidPreviousAnnouncement"
    },
    on: {
      "click": function($event) {
        _vm.$bvModal.show('readCovidPreviousAnnouncement')
      }
    }
  }, [_vm._v("Previous Announcement Re: COVID-19")]) : _vm._e(), (_vm.props.acf.homelatestsannouncementcontent) ? _c('b-modal', {
    attrs: {
      "id": "readCovidPreviousAnnouncement",
      "size": "xl",
      "hide-footer": "",
      "title": _vm.props.acf.homelatestannouncementheading
    }
  }, [_c('div', {
    staticClass: "simple-modal-content"
  }, [_c('div', {
    staticClass: "content",
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.homelatestsannouncementcontent)
    }
  })])]) : _vm._e()], 1)])]), _c('section', {
    staticClass: "scrolled-sec",
    attrs: {
      "id": "technology"
    }
  }, [(_vm.props.acf.hometechnologyheading) ? _c('h3', {
    staticClass: "heading",
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.hometechnologyheading)
    }
  }) : _vm._e(), _c('div', {
    staticClass: "technology-slider"
  }, [_c('swiper', {
    attrs: {
      "options": _vm.swiperOption4
    }
  }, _vm._l((_vm.props.acf.hometechnologiesslider), function(technologySlider, k) {
    return _c('swiper-slide', {
      key: technologySlider.id,
      style: ({
        backgroundImage: 'url(' + technologySlider.backgroundimage + ')'
      }),
      attrs: {
        "id": "swiper-slide" + k
      }
    }, [_c('div', {
      staticClass: "slide-content-wrapper",
      attrs: {
        "id": "slide-inner" + k
      }
    }, [(technologySlider.technologyimage) ? _c('div', {
      staticClass: "content-picture",
      style: ({
        backgroundImage: 'url(' + technologySlider.technologyimage + ')'
      })
    }) : _vm._e(), (technologySlider.technologyname) ? _c('div', {
      staticClass: "content-inner"
    }, [_c('div', {
      staticClass: "content-caption"
    }, [_c('h3', {
      domProps: {
        "innerHTML": _vm._s(technologySlider.technologyname)
      }
    }), _c('div', {
      staticClass: "content",
      domProps: {
        "innerHTML": _vm._s(technologySlider.technologyinfo)
      }
    }), (technologySlider.technologymobileimage) ? _c('div', {
      staticClass: "mobile-picture",
      style: ({
        backgroundImage: 'url(' + technologySlider.technologymobileimage + ')'
      })
    }) : _vm._e(), (technologySlider.technologyinfo) ? _c('b-button', {
      directives: [{
        name: "b-modal",
        rawName: "v-b-modal.modal-scrollable",
        modifiers: {
          "modal-scrollable": true
        }
      }],
      staticClass: "modal-trigger blue",
      attrs: {
        "id": "readTechnologyBtn" + k
      },
      on: {
        "click": function($event) {
          _vm.$bvModal.show('readTechnology' + k)
        }
      }
    }, [_vm._v("Read More")]) : _vm._e(), (technologySlider.technologyinfo) ? _c('b-modal', {
      attrs: {
        "id": "readTechnology" + k,
        "size": "xl",
        "hide-footer": "",
        "title": technologySlider.technologyname
      }
    }, [_c('div', {
      staticClass: "simple-modal-content"
    }, [_c('div', {
      staticClass: "content",
      domProps: {
        "innerHTML": _vm._s(technologySlider.technologyinfo)
      }
    })])]) : _vm._e()], 1)]) : _vm._e(), _c('div', {
      staticClass: "swiper-button-prev swiper-button-prev4",
      attrs: {
        "slot": "button-prev"
      },
      slot: "button-prev"
    }, [_c('div', {
      staticClass: "fa fa-angle-left"
    })]), _c('div', {
      staticClass: "swiper-button-next swiper-button-next4",
      attrs: {
        "slot": "button-next"
      },
      slot: "button-next"
    }, [_c('div', {
      staticClass: "fa fa-angle-right"
    })])])])
  }))], 1)]), _c('section', {
    staticClass: "scrolled-sec",
    attrs: {
      "id": "media"
    }
  }, [_c('div', {
    staticClass: "section-container"
  }, [(_vm.props.acf.homemeadiaheading) ? _c('h3', {
    staticClass: "heading",
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.homemeadiaheading)
    }
  }) : _vm._e(), _c('div', {
    staticClass: "section-banner",
    style: ({
      backgroundImage: 'url(' + _vm.props.acf.homemeadiabackgroundimage + ')'
    })
  }), (_vm.props.acf.homemedias) ? _c('div', {
    staticClass: "media-blocks"
  }, _vm._l((_vm.props.acf.homemedias), function(Media, m) {
    return _c('div', {
      directives: [{
        name: "b-modal",
        rawName: "v-b-modal",
        value: ('mediaModal' + m),
        expression: "'mediaModal' + m"
      }],
      staticClass: "media-block modal-trigger"
    }, [(Media.image) ? _c('div', {
      staticClass: "media-background",
      style: ({
        backgroundImage: 'url(' + Media.image + ')'
      })
    }) : _vm._e(), _c('div', {
      staticClass: "media-content"
    }, [_c('h4', {
      domProps: {
        "innerHTML": _vm._s(Media.heading)
      }
    })]), _c('b-modal', {
      attrs: {
        "id": "mediaModal" + m,
        "size": "lg",
        "hide-footer": ""
      }
    }, [_c('div', {
      staticClass: "modal-inner-contents"
    }, _vm._l((Media.medialist), function(MediaList) {
      return _c('div', {
        staticClass: "modal-inner-content"
      }, [_c('a', {
        attrs: {
          "href": MediaList.link,
          "target": "_blank"
        }
      }, [(MediaList.image) ? _c('div', {
        staticClass: "modal-inner-background",
        style: ({
          backgroundImage: 'url(' + MediaList.image + ')'
        })
      }) : _vm._e(), _c('h3', {
        domProps: {
          "innerHTML": _vm._s(MediaList.heading)
        }
      })])])
    }))])], 1)
  })) : _vm._e()])])], 1), _c('Footer')], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-939409f8","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/pages/home/home.pug
// module id = 811
// module chunks = 1